import React, { Component } from 'react';
import { CardMedia, CardText } from 'react-toolbox/lib/card';
import Card from 'components/Card';
import logoImg from 'images/sp-logo.svg';
import styles from './thankyou.scss';

class RefigureThankYou extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <Card theme={styles}>
          <CardMedia>
            <img className={styles.spLogo} alt="Service Pros logo" src={logoImg} />
          </CardMedia>
          <CardText>
            Thank you for submitting a refigure to Service Pros.
            Please allow 24 hours for processing unless the refigure was indicated as a rush job.
            If you have any questions or concerns, please contact us at 336-792-4111.
          </CardText>
        </Card>
      </div>
    );
  }
}

RefigureThankYou.propTypes = {
};

export default RefigureThankYou;



// WEBPACK FOOTER //
// ./client/app/screens/refigure/thankyou/index.jsx